import { Flex, DatePicker, Button, InputNumber, Form, Space, Input, Select, message, Row, Col, Popconfirm } from "antd";
import { serverFetch } from "../../server";
import { datPeriodVids } from "../../extensions/helper";
import { useState, useEffect } from "react";
import { strDate2Server } from "../../extensions/utils";
import dayjs from "dayjs";
import { isMobile } from "../../extensions/design";

const { TextArea } = Input;

const ClientAbonStatusChange = ({ onUpdate, recordId }) => {
  const [form] = Form.useForm();
  const [addDateValue, setAddDateValue] = useState(null);
  const [addDateUnit, setAddDateUnit] = useState(1);
  const [loading, setLoading] = useState(false);
  const [itmStatusList, setItmStatusList] = useState([]);

  useEffect(() => {
    getStatusData();
  }, []);

  const handleResetAddDate = () => {
    setAddDateValue(null);
    setAddDateUnit(1);
  };

  const getStatusData = () => {
    setLoading(true);
    serverFetch(`sale/statusmoveget/${recordId}`)
      .then((data) => {
        setItmStatusList(data);
        form.setFieldsValue({
          ...data,
          docDate: dayjs(data.docDate),
        });
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };

  const statusChange = () => {
  const values = form.getFieldsValue();

  let docDate = values.docDate;

  if (docDate)
  {
    if (addDateValue && addDateUnit) {
      if (addDateUnit === 1) docDate = docDate.add(addDateValue, "day");
      else if (addDateUnit === 31) docDate = docDate.add(addDateValue, "month");
      else if (addDateUnit === 365) docDate = docDate.add(addDateValue, "year");
    }
  }

  const finalPayload = {
    ...itmStatusList,
    comment: values.comment || "",
    docDate: strDate2Server(docDate),
  };

  setLoading(true);
  serverFetch("sale/statusmoveupdate", {
    method: "PUT",
    bodyData: finalPayload,
  })
    .then(() => {
      onUpdate();
      setLoading(false);
    })
    .catch((e) => {
      setLoading(false);
      message.error(e.userMessage || "Ошибка при обновлении статуса");
    });
};

  const filteredDateUnits = Array.from(
    new Map(
      datPeriodVids
        .filter(({ value }) => value !== 0)
        .map((item) => [item.value, item])
    ).values()
  );
  const deleteStatus = () => {
    setLoading(true);
    serverFetch(`sale/statusmovedelete/${recordId}`, {
      method: "DELETE",
    })
      .then(() => {
        message.success("Статус успешно удален");
        onUpdate();
      })
      .catch((e) => {
        message.error(e.userMessage || "Ошибка при удалении статуса");
      }) 
      .finally(() => setLoading(false));
  };

  /** Попап подтверждения — внутри панели клиента (.sport-modal-content), иначе центрирующие стили / body дают смещение влево */
  const getStatusPopconfirmContainer = (trigger) =>
    trigger.closest(".sport-modal-content") ??
    trigger.closest(".client-abon-status-change-footer") ??
    document.body;
    
  const content = !isMobile ? [
    <Form form={form} className="subtable-item" colon={false}>
      <Col>
        <Row>
          <Form.Item label="Дата движения" style={{ width: 260 }} name="docDate" rules={[{ required: true, message: "Выберите дату" }]}>
            <DatePicker format="DD.MM.YYYY" allowClear={false}/>
          </Form.Item>
        </Row>
        <Row>
        <Col span={1}/>
          <Form.Item label="Комментарий" name="comment">
            <TextArea rows={3} placeholder="Введите комментарий" style={{ width: 312 }}/>
          </Form.Item>
        </Row>  
        <Form.Item label=" Прибавл. к дате">
          <Space align="start">
            <InputNumber min={1} placeholder="Кол-во" value={addDateValue} onChange={setAddDateValue} style={{ width: 100 }}/>
            <Select value={addDateUnit} onChange={setAddDateUnit}>
              {filteredDateUnits.map(({ value, label }) => (
                <Select.Option key={value} value={value}>{label}</Select.Option>
              ))}
            </Select>
            <Button onClick={handleResetAddDate}>Сбросить</Button>
          </Space>
        </Form.Item>
          
          <Flex justify="space-between" style={{ marginTop: "16px" }} className="client-abon-status-change-footer">
            <Popconfirm
              title="Подтверждение"
              description="Удалить статус?"
              onConfirm={deleteStatus}
              placement="top"
              getPopupContainer={getStatusPopconfirmContainer}
            >
              <Button disabled={itmStatusList.status === 1}>Удалить</Button>
            </Popconfirm>
            <Space>
              <Button onClick={statusChange}>Сохранить</Button>
              <Button onClick={handleResetAddDate}>Отмена</Button>
            </Space>
          </Flex>
      </Col>
    </Form>
  ] : [
    <Form form={form} colon={false} labelCol={{ flex: "120px" }} wrapperCol={{ flex: "1" }} className="client-subitem-content" >
    <Form.Item label="Дата движения" name="docDate" rules={[{ required: true, message: "Выберите дату" }]}>
      <DatePicker format="DD.MM.YYYY" className="client-abon-form-item" allowClear={false}/>
    </Form.Item>
    <Form.Item label="Комментарий" name="comment">
      <TextArea rows={3} placeholder="Введите комментарий" className="client-abon-form-item"/>
    </Form.Item>
    <Form.Item label=" Прибавл. к дате"> 
      <div className="client-flexible-container-for-forms">
        <InputNumber className="client-abon-status-date-days" min={1} value={addDateValue} onChange={setAddDateValue}/>
        <Select className="client-abon-status-date-type-select" value={addDateUnit} onChange={setAddDateUnit}>
          {filteredDateUnits.map(({ value, label }) => (
            <Select.Option key={value} value={value}>{label}</Select.Option>
          ))}
        </Select>
        <Button onClick={handleResetAddDate} style={{ flex: '0 0 50px', whiteSpace: 'nowrap' }}>Сброс</Button>
      </div>
    </Form.Item>
      <div className="client-item-line-triple-halfed">
        <Popconfirm
          title="Подтверждение"
          description="Удалить статус?"
          onConfirm={deleteStatus}
          placement="top"
          getPopupContainer={getStatusPopconfirmContainer}
        >
          <Button disabled={itmStatusList.status === 1}>Удалить</Button>
        </Popconfirm>
        <Button onClick={statusChange}>Сохранить</Button>
        <Button onClick={handleResetAddDate}>Отмена</Button>
      </div>
    </Form>
  ]

  return (
    <>
      {content}
    </>
  );
};
export default ClientAbonStatusChange;
